import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
  return typeof error === 'object' && error != null && 'status' in error;
}

/**
 * The reason the backend gave for refusing a request, when it gave one. apisupport answers with an
 * ApiError: `errors` holds the details — every broken field of a body that failed validation, or the
 * one rule a write broke — and `message` only sums them up ("Invalid request content." for a bad
 * body), so the details come first and `message` stands in when there are none.
 */
export function backendMessageOf(error: unknown): string | undefined {
  if (!isFetchBaseQueryError(error)) return undefined;
  const { data } = error;
  if (typeof data !== 'object' || data == null) return undefined;
  const { errors, message } = data as { errors?: unknown; message?: unknown };
  if (Array.isArray(errors)) {
    const details = errors.filter(
      (item): item is string => typeof item === 'string' && item !== '',
    );
    if (details.length > 0) return details.join('; ');
  }
  return typeof message === 'string' && message ? message : undefined;
}

export function isErrorWithMessage(error: unknown): error is { message: string } {
  return (
    typeof error === 'object' &&
    error != null &&
    'message' in error &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof (error as any).message === 'string'
  );
}
